import { useCallback, useMemo } from "react";
import { useUiLocale } from "../context/UiLocaleContext";
import en from "../locales/en.json";
import he from "../locales/he.json";

type MessageNode = string | { [key: string]: MessageNode };

const bundles: Record<"en" | "he", MessageNode> = {
  en: en as MessageNode,
  he: he as MessageNode,
};

function getNested(tree: MessageNode, path: string): string | undefined {
  const parts = path.split(".");
  let cur: MessageNode | undefined = tree;
  for (const p of parts) {
    if (cur === undefined || typeof cur === "string") return undefined;
    cur = cur[p];
  }
  return typeof cur === "string" ? cur : undefined;
}

export function useTranslation() {
  const { uiLocale } = useUiLocale();

  const t = useCallback(
    (key: string, vars?: Record<string, string | number>) => {
      let s =
        getNested(bundles[uiLocale], key) ??
        getNested(bundles.en, key) ??
        key;
      if (vars) {
        Object.entries(vars).forEach(([k, v]) => {
          s = s.replace(new RegExp(`{{\\s*${k}\\s*}}`, "g"), String(v));
        });
      }
      return s;
    },
    [uiLocale]
  );

  return useMemo(() => ({ t, uiLocale }), [t, uiLocale]);
}
